export default "__VITE_ASSET__hiGr2vkA__"